import moment from "moment/moment";
import {enqueueSnackbar} from "notistack";
import {useState} from "react";
import {
  useFollowUpDateGroupModal,
  useSaveDisqualifiedReasonMutation,
  useSaveExpectedCloseDateMutation,
  useSaveStatusMutation
} from '../../../shared';
import { enrollmentApolloClient, GraphQLErrorType } from '@coverright/data-access/apollo-clients';
import { DisqualifiedReasonDto, StatusDto } from '@coverright/data-access/types/enrollment';


export function useSaveStatus(onCompleted: () => void, clientId?: string) {
  const [loading, setLoading] = useState(false)
  const [saveExpectedCloseDate] = useSaveExpectedCloseDateMutation();
  const [saveDisqualifiedReason] = useSaveDisqualifiedReasonMutation();
  const changeFollowUpDateForGroup = useFollowUpDateGroupModal();
  const [saveStatus] = useSaveStatusMutation({
    onError: (error) => {
      let text;
      switch (error.graphQLErrors[0]?.extensions?.type) {
        case GraphQLErrorType.NO_CONNECTION:
          text = "Service is not available";
          break;
        default:
          text = "Unknown error"
      }
      enqueueSnackbar(text, {variant: "error"});
    },
    onCompleted: () => {
      enqueueSnackbar('Status saved!', {variant: "success"});
      onCompleted();
    }
  });

  const save = async ({status, agentId, disqualifiedReason, expectedCloseDate, followUpDate}: {status?: StatusDto, agentId?: string, followUpDate?: string | null, expectedCloseDate?: string | null, disqualifiedReason?: DisqualifiedReasonDto | null}) => {
    if (!status) return;

    setLoading(true);
    try {
      if ([StatusDto.FollowUp, StatusDto.Contacted, StatusDto.SalesQualified].includes(status) ) {
        if (followUpDate) {
          const followUpDateStr = moment(followUpDate).format('YYYY-MM-DD');
          await saveStatus({
            variables: {
              id: clientId,
              status,
              followUpDate: followUpDateStr,
              agentId,
            }
          });
          const expectedCloseDateStr = expectedCloseDate ? moment(expectedCloseDate).format('YYYY-MM-DD') : undefined;
          if (expectedCloseDate) {
            await saveExpectedCloseDate({
              variables: {
                id: clientId,
                expectedCloseDate: expectedCloseDateStr,
              }
            })
          }
          if (clientId) {
            await changeFollowUpDateForGroup(clientId, followUpDateStr, status, agentId, expectedCloseDateStr);
          }
        } else {
          return;
        }
      } else if (status === StatusDto.Disqualified && disqualifiedReason) {
        await saveStatus({
          variables: {
            id: clientId,
            status,
            agentId,
          }
        })
        await saveDisqualifiedReason({
          variables: {
            id: clientId,
            disqualifiedReason,
          }
        })
      } else {
        await saveStatus({
          variables: {
            id: clientId,
            status,
            agentId,
          }
        })
      }
      await enrollmentApolloClient.refetchQueries({
        include: ['agentDashboardCounters', 'salesQualifiedFuture', 'salesQualified', 'followUps', 'followUpsFuture', 'contacted', 'attemptedLeads']
      })
    } finally {
      setLoading(false);
    }

  };

  return {save, loading}
}

